<template>
  <div class="mt-5 card" data-testid="partner-contact-form">
    <h2 class="text-headline-m">{{ t('PartnerCompany.contactForAppointments') }}</h2>
    <p class="mt-2">{{ t('PartnerCompany.contactForAppointmentsHelpText') }}</p>
    <hr class="dark:bg-gray-700 my-4 h-px border-0 bg-surface-elevation-5" />

    <TextInput v-model="model.firstname" class="mb-5" :label="t('ContactEditForm.firstName')" data-testid="partner-contact-firstname" />
    <TextInput v-model="model.name" class="mb-5" :label="t('ContactEditForm.name')" data-testid="partner-contact-name" />
    <TextInput v-model="model.title" class="mb-5" :label="t('ContactEditForm.position')" data-testid="partner-contact-title" />
    <TextInput
      v-model="model.email"
      class="mb-5"
      :label="t('ContactEditForm.email')"
      :error="getValidationErrors(v$.email)"
      data-testid="partner-contact-email"
    />
    <TextInput
      v-model="model.phone"
      class="mb-5"
      :label="t('ContactEditForm.phone')"
      :error="getValidationErrors(v$.phone)"
      data-testid="partner-contact-phone"
    />
  </div>
</template>
<script setup lang="ts">
import { TextInput } from '@ramp106/omrjs-core-ui/deprecated'
import type { Validation } from '@vuelidate/core'
import { useI18n } from 'vue-i18n'

import type { UpdateContactMutationVariables } from '@/gql/myomr'
import { getValidationErrors } from '@/helpers/validationHelper'

const { t } = useI18n()

defineProps<{
  v$: Validation
}>()

const model = defineModel<Omit<UpdateContactMutationVariables, 'id'>>({
  default: () => ({
    firstname: '',
    name: '',
    title: '',
    email: '',
    phone: '',
  }),
})
</script>
